module.exports = __webpack_public_path__ + "res/Roboto-BlackItalic-webfont.woff?17381569eb2849621b247537702b06db";


//////////////////
// WEBPACK FOOTER
// ./assets/fonts/roboto/Roboto-BlackItalic-webfont.woff
// module id = 93
// module chunks = 0